export default "__VITE_ASSET__Dzgpmdgc__"